import React, { Component } from 'react'
import Axios from 'axios'
import Loader from '../Loader'
import './HeaderMapping.css'
import { Urls } from '../../Urls'
import { toast, ToastContainer } from 'react-toastify'
import ProgressBar from '../ProgressBar/ProgressBar'
import { logActivity } from '../Utilities'
let mapped_head = []
class HeaderMapping extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataset_id: localStorage.getItem("dataset_id"),
            cl_heads: [],
            dc_heads: [],
            mapped_header: null,
            loader: false
        }
    }

    componentDidMount = () => {

        // logActivity([
        //     {
        //         'screen': 'Header Mapping',
        //         'module': 'Header Mapping',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])


        document.getElementById('header').style.opacity = '0.5'

        if (localStorage.getItem("userid") && localStorage.getItem("dataset_id")) {
            document.title = "DC | Header Mapping"
            const body = {
                "dataset_id": localStorage.getItem("dataset_id")
            }
            this.setState({
                loader: true
            }, () => {
                document.getElementById("header").style.opacity = "0.5"
                Axios.post(Urls.header_mapping, body)
                    .then(res => {
                        this.setState({
                            cl_heads: res.data.client_head,
                            dc_heads: res.data.DC_head,
                            loader: false
                        })
                        var i = 0
                        for (i = 0; i < this.state.cl_heads.length; i++) {
                            mapped_head.push({
                                'client': this.state.cl_heads[i],
                                'Datacleaning_format': null
                            })
                        }
                        this.setState({
                            mapped_header: mapped_head
                        })
                        document.getElementById("header").style.opacity = "1"
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({
                            loader: false
                        })
                        toast.error("Error while processing your request")
                        document.getElementById('header').style.opacity = 1
                    })
            })
        }
        else {
            toast.error("Please Log In", this.props.history.push({ pathname: "/user_details" }))
        }

    }

    changeHandler = (event) => {
        console.log(event.target.value)
        if (event.target.value === '-- SELECT HEADER --') {
            mapped_head[event.target.id] = {
                "client": event.target.name,
                "Datacleaning_format": null
            }
        }
        else {
            mapped_head[event.target.id] = {
                "client": event.target.name,
                "Datacleaning_format": event.target.value
            }
        }
        this.setState({
            mapped_header: mapped_head
        })
    }

    clickHandler = () => {
        var duplicateHeaders = []
        var validation_mapped_headers = []
        var t = 0
        for (t = 0; t < this.state.mapped_header.length; t++) {
            if (this.state.mapped_header[t]['Datacleaning_format'] != null) {
                validation_mapped_headers.push(this.state.mapped_header[t]['Datacleaning_format'])
            }
        }

        // console.log(validation_mapped_headers)
        for (t = 0; t < validation_mapped_headers.length; t++) {
            var count = 0
            var tmp = validation_mapped_headers[t]
            var j = 0
            for (j = 0; j < validation_mapped_headers.length; j++) {
                if (tmp === '-- SELECT HEADER --') {
                    console.log('passed')
                }
                else {
                    if (tmp === validation_mapped_headers[j]) {
                        count = count + 1
                    }
                    if (count > 1) {
                        console.log(`Duplicate found for header: ${tmp}`)
                        // document.getElementById
                        window.alert(`Duplicate entry for header: ${tmp}`)
                        duplicateHeaders.push(tmp)
                        break;
                    }
                }
            }
            if (count > 1) {
                break;
            }
        }

        if (duplicateHeaders.length === 0) {
            // logActivity([
            //     {
            //         'screen': 'Header Mapping',
            //         'module': 'Header Mapping',
            //         'user_activity': 'headers submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            const body = {
                'dataset_id': localStorage.getItem('dataset_id'),
                'mapped_header': this.state.mapped_header
            }
            console.log(this.state.mapped_header)
            // Call API

            this.setState({ loader: true })
            document.getElementById("header").style.opacity = "0.5"
            Axios.post(Urls.calculation, body)
                .then(response => {
                    console.log(response)
                    sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                    this.props.history.push({
                        pathname: "/uniqueLocation"
                    })
                    this.setState({
                        loader: false
                    })
                })
                .catch(error => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    toast.error("Error while processing your request")
                    console.log(error)
                })
        }



    }

    goBack = () => this.props.history.push({ pathname: "/file_upload" })

    render() {
        const cl_heads = this.state.cl_heads
        const dc_heads = this.state.dc_heads
        return (
            <div>
                <ToastContainer />
                <div id="header" className="row container" align="center" style={{ marginLeft: '5%' }}>
                    <div className="col-1">
                        <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                    </div>
                    <div className="col-10">
                        <div className="row" style={{ marginTop: '2%' }}>
                            <div className="col-4">
                                <div className="header_card text-left">
                                    <b align="center"><u>Important steps:</u></b><br /><br></br>
                                    <div>
                                        <ul type="circle">
                                            <li >
                                                1) Please confirm & validate the columns header from your input file.
                                    </li>
                                            <li>
                                                2) In the input file header column show/dipsplay.
                                    </li>
                                            <li>
                                                3) Map the required headers with the corresponding input file data fields.
                                    </li>
                                        </ul>
                                    </div>
                                    <br></br><br></br><br></br><br></br>
                                    <div id="header_note">
                                        <b align="center"><u>Note: </u><br></br>Please do not select same header for multiple input file headers.</b>
                                    </div>
                                </div>
                            </div>
                            <div className="col-8" style={{ "margin-bottom": "2% !important" }}>
                                <table id="header_mapping_table" border="1">
                                    <tbody>
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>Input File Headers</th>
                                            <th>Required Headers</th>
                                        </tr>
                                        {
                                            cl_heads.map((cl_head, i) =>
                                                <tr>
                                                    <td> {i + 1} </td>
                                                    <td>
                                                        {cl_head}
                                                    </td>
                                                    <td>
                                                        <select id={i} className="test" name={cl_head} onChange={this.changeHandler} >
                                                            <option selected value={null}>-- SELECT HEADER --</option>
                                                            {
                                                                dc_heads.map((dc_head, j) =>
                                                                    <option name={j} value={dc_head} > {dc_head} </option>
                                                                )
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <Loader isLoading={this.state.loader} />
                        </div>
                    </div>
                    <div className="col-1 navButtonsCircleRight">
                        <button onClick={this.clickHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="24%" />
                </div>
            </div>
        )
    }
}

export default HeaderMapping
